import { useEffect, useState } from 'react';
import { formatCurrency } from 'utils/utils';
import { Button } from '../Button';
import Loader from 'components/Loader';
import ProductQtyInput from 'components/ProductQtyInput';
import ShoppingCartService from '../services/shopping-cart.service';
import { OtherFabricSelector } from '../OtherFabricSelector';
import { useErrorBoundary } from "basket/ErrorBoundary";

export function BasketEditFabricItem(props) {
    const { item, updateFabricItem, close } = props;

    const [quantity, setQuantity] = useState(item.quantity);
    const [loading, setloading] = useState(false);
    const [price, setPrice] = useState(item.price);
    const handleError = useErrorBoundary();
    const isPerRoll = item.productType === 12 && item.fabric.wallpaperMeasurementUnit === 3;

    const [itemTitle, setItemTitle] = useState(item.title);
    const [isSubmitDisabled, setSubmitDisabled] = useState(false);
    const [errors, setErrors] = useState({});
    const [fabrics, setFabrics] = useState([]);
    const [totalFabricsCount, setTotalFabricsCount] = useState(0);
    const [selectedFabricId, setSelectedFabricId] = useState(item.fabricId);
    const [selectedFabricData, setSelectedFabricData] = useState({
        collectionName: item.collectionName,
        collectionUrl: item.collectionUrl,
        colour: item.colour,
        quantityUnitPrice: item.quantityUnitPrice
    });

    useEffect(() => {
        console.log('item', item);
    }, [item]);

    useEffect(() => {
        console.log('isPerRoll', isPerRoll)
    }, [isPerRoll])

    const loadFabrics = async () => {
        setloading(true);
        const response = await ShoppingCartService.get(
            'same-fabrics?fabricId=' + item.fabricId + '&productType=' + item.productType
        );
        setFabrics(response.fabrics);
        setTotalFabricsCount(response.totalCount);
        setloading(false);
    };

    const loadAllFabrics = async () => {
        setloading(true);
        const response = await ShoppingCartService.get(
            'same-fabrics?fabricId=' + item.fabricId + '&productType=' + item.productType + '&showAll=true'
        );
        setFabrics(response.fabrics);
        setTotalFabricsCount(response.totalCount);
        setloading(false);
    };

    const createItem = () => ({
        ...item,
        fabricId: selectedFabricId,
        productType: item.productType,
        quantity: quantity
    });

    const updatePrice = async () => {
        const result = await ShoppingCartService.create('price', createItem())
            .catch(_ => {
                handleError('Could not load item price. Please contact administrator');
            });

        if (result) {
            setPrice(result.price);
        }
    };

    const validatePrice = async (callback) => {
        const url = item.productType === 12
            ? '/api/product/wallpapers/validate'
            : '/api/product/fabric/validate';

        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({
                quantity: quantity
            })
        })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(err => { throw err; });
                }

                return response.json();
            })
            .then(() => {
                setErrors({});
                callback();
            })
            .catch(jsonResponse => {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    ...jsonResponse
                }));
            });
    };

    const handleQuantityChange = (value) => {
        setQuantity(value);
    };

    const handlerUpdate = async () => {
        setloading(true);

        if (item.productType === 11 && quantity < 1) {
            setErrors(prev => ({
                ...prev,
                Quantity: 'Please ensure the quantity is at least 1.0 metres'
            }));
            setloading(false);
            return;
        }

        await updateFabricItem(createItem());
        setloading(false);
    };

    useEffect(() => {
        const foundFabric = fabrics.find(fabric => fabric.fabricId === selectedFabricId);
        if (foundFabric) {
            setItemTitle(foundFabric.fullName);
            setSelectedFabricData({
                collectionName: foundFabric.collectionName,
                collectionUrl: foundFabric.collectionUrl,
                colour: foundFabric.colour,
                quantityUnitPrice: isPerRoll
                    ? `${quantity} rolls (£${foundFabric.displayPrice} per roll)`
                    : `${Number(quantity || 0).toFixed(1)} metres (£${foundFabric.displayPrice} per metre)`
            });
            updatePrice();
        }
    }, [selectedFabricId]);

    useEffect(() => {
        const foundFabric = fabrics.find(fabric => fabric.fabricId === selectedFabricId);
        if (foundFabric) {
            setSelectedFabricData(prev => ({
                ...prev,
                quantityUnitPrice: isPerRoll
                    ? `${quantity} rolls (£${foundFabric.displayPrice} per roll)`
                    : `${Number(quantity || 0).toFixed(1)} metres (£${foundFabric.displayPrice} per metre)`
            }));
        }
    }, [quantity]);

    useEffect(() => {
        if (quantity !== '' && Number(quantity) >= 0) {
            validatePrice(updatePrice);
        }
    }, [quantity]);

    useEffect(() => {
        loadFabrics();
    }, []);

    useEffect(() => {
        setSubmitDisabled(Object.keys(errors).length > 0);
    }, [errors]);

    return (
        <Loader isLoading={loading}>
            <div className="row">
                <div className="col">
                    <div className="subtitle1 mb-16 sm-text-24 default-text">{`Edit ${itemTitle}`}</div>
                </div>
                <div className="col-auto ps-24">
                    <span className="curtains-icon curtains-icon-close size-24 show-btn hide-btn" onClick={() => close()} />
                </div>
            </div>

            <OtherFabricSelector
                fabrics={fabrics}
                totalFabricsCount={totalFabricsCount}
                loadAllFabrics={loadAllFabrics}
                selectedFabric={selectedFabricId}
                setSelectedFabric={setSelectedFabricId}
            />

            <div>
                <div>
                    <span className="gray">Collection: </span>
                    <a href={selectedFabricData.collectionUrl} className="underline">{selectedFabricData.collectionName}</a>
                </div>
                <div>
                    <span className="gray">Colour:</span> {selectedFabricData.colour || 'None'}
                </div>
                <div>
                    <span className="gray">Qty: {selectedFabricData.quantityUnitPrice}</span>
                </div>
            </div>

            <div className="body-text4">{formatCurrency(price, 2)}</div>

            <div className="mb-16 mt-32" id="updateProductQuantity">
                <div className="dashed-line mb-24"></div>
                <div className="body-text3 gray mb-16">Quantity:</div>

                <ProductQtyInput
                    initValue={Number(quantity)}
                    onlyInt={item.productType === 12}
                    digits={item.productType === 12 ? 0 : 1}
                    changeStep={item.productType === 12 ? 1 : 0.1}
                    label={isPerRoll ? 'rolls' : 'metres'}
                    onChange={handleQuantityChange}
                />

                {errors.Quantity && (
                    <span className="field-validation-error">{errors.Quantity}</span>
                )}
            </div>

            <div className="d-flex gap-16 mb-16 sm-column md-column sm-gap-8 sm-mb-0">
                <div className="w-100 show-btn hide-btn">
                    <Button
                        name="UPDATE"
                        onClick={async () => await handlerUpdate()}
                        disabled={isSubmitDisabled || Object.keys(errors).length > 0}
                    />
                </div>
            </div>
        </Loader>
    );
}